import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { initAudio } from '../lib/sound';
import { toast } from 'sonner';
import { LogIn } from 'lucide-react';

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    initAudio(); // unlock audio on first user gesture
    setLoading(true);
    try {
      await login(username.trim(), password);
      nav('/dashboard');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Falha no login');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 to-slate-50 flex flex-col items-center justify-center p-6">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <div className="w-20 h-20 rounded-3xl bg-orange-500 text-white grid place-items-center font-black text-3xl shadow-lg shadow-orange-500/30">LU</div>
          <h1 className="mt-4 text-2xl font-black tracking-tight">LU SCHOOL SNACKS</h1>
          <p className="text-slate-500 text-sm mt-1">Cantina escolar · gestão completa</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl shadow-xl border border-slate-200 p-6 space-y-4" data-testid="login-form">
          <div>
            <label className="text-xs font-semibold text-slate-600 mb-1 block">Usuário</label>
            <input value={username} onChange={(e) => setUsername(e.target.value)} autoCapitalize="none" autoCorrect="off"
                   data-testid="login-username" className="w-full h-12 rounded-xl border border-slate-200 px-4 text-base focus:outline-none focus:ring-2 focus:ring-orange-500" placeholder="admin"/>
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-600 mb-1 block">Senha</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                   data-testid="login-password" className="w-full h-12 rounded-xl border border-slate-200 px-4 text-base focus:outline-none focus:ring-2 focus:ring-orange-500" placeholder="••••••"/>
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit"
                  className="w-full h-12 rounded-xl bg-orange-500 text-white font-bold flex items-center justify-center gap-2 hover:bg-orange-600 active:scale-[0.98] transition-transform disabled:opacity-50">
            <LogIn size={18} /> {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
        <div className="mt-4 text-center text-xs text-slate-500">
          Contas de demonstração: admin/admin123 · func1/func123 · func2/func123 · func3/func123
        </div>
      </div>
    </div>
  );
}
